import { atomFamily } from "recoil";


export const CodeMirrorCodeState = atomFamily<string, string>({
  key: "CodeMirrorCodeState",
  default: "",
});
